import { c as _c } from "react/compiler-runtime";
const TitleOverlay = t0 => {
  const $ = _c(2);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <div className="absolute bottom-6 left-6 z-10 pointer-events-none"><h4 className="text-white text-xl lg:text-3xl font-bold drop-shadow-lg">{title}</h4></div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default TitleOverlay;